import React from 'react';
import { Card, Empty } from 'antd';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell,
} from 'recharts';

interface TopPerformersChartProps {
  data: any[];
  title: string;
  loading?: boolean;
}

const COLORS = ['#1890ff', '#52c41a', '#faad14', '#f5222d', '#722ed1', '#eb2f96', '#fa8c16', '#13c2c2'];

const TopPerformersChart: React.FC<TopPerformersChartProps> = ({ 
  data, 
  title,
  loading = false 
}) => {
  if (!data || data.length === 0) {
    return (
      <Card title={title} loading={loading}>
        <Empty description="ບໍ່ມີຂໍ້ມູນ" />
      </Card>
    );
  }

  const chartData = data.map(item => ({
    name: item.user.name,
    revenue: item.totalRevenue,
    count: item.serviceCount,
  }));

  const formatCurrency = (value: number) => {
    return `${(value / 1000).toFixed(0)}K`;
  };

  return (
    <Card title={title} loading={loading}>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart data={chartData} layout="horizontal">
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" tickFormatter={formatCurrency} />
          <YAxis 
            dataKey="name" 
            type="category" 
            width={100}
            tick={{ fontSize: 12 }}
          />
          <Tooltip 
            formatter={(value: number, name: string) => {
              if (name === 'revenue') {
                return [`${value.toLocaleString()} ກີບ`, 'ລາຍຮັບ'];
              }
              return [value, 'ຈຳນວນ'];
            }}
          />
          <Legend />
          <Bar dataKey="revenue" name="ລາຍຮັບ (ກີບ)">
            {chartData.map((_:any, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
};

export default TopPerformersChart;